/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom';

import { DataTableList } from '../../components/DataTable/DataTableList';
import TopBar from '../../components/TopBar'
import AddNewCustomer from './AddNewCustomer';
import DeleteConfirmationPopup from '../../components/DeleteConfirmationPopup';

import Delete from "../../assets/images/delete.svg";
import penIcon from "../../assets/images/pen-img.svg";
import premiumIcon from "../../assets/images/premium.png";
import searchIcon from "../../assets/images/icon-search.svg";

import { createCustomer, getCustomers, deleteCustomers, getAllCustomersWithoutPagination } from '../../api/customersApi';
import { exportToCSV } from '../../utils/functions';

import '../../assets/css/customer.css'
import UploadMediaPopup from '../../components/UploadMediaPopup';

const Customers = () => {

    const popupRef = useRef();
    const deletePopupRef = useRef()

    const [customerList, setCustomerList] = useState([]);
    const [isLoadingData, setIsLoadingData] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [isAllSelected, setIsAllSelected] = useState(false);
    const [columnWidths, setColumnWidths] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [toggleSelect, setToggleSelect] = useState(false);

    const [isNewUserCreate, setIsNewUserCreate] = useState(false);
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [deleteTarget, setDeleteTarget] = useState(null);

    const [searchInput, setSearchInput] = useState('');
    const [error, setError] = useState('')

    const [showUploadMediaPopup, setShowUploadMediaPopup] = useState(false);
    const [uploadMediaPopupFor, setUploadMediaPopupFor] = useState('');
    const [uploadMediaPopupTab, setUploadMediaPopupTab] = useState('upload');
    const [selectedFeatureImage, setSelectedFeatureImage] = useState('');
    const [isExportLoading, setIsExportLoading] = useState(false);
    const [isDeleteCustomerLoading, setIsDeleteCustomerLoading] = useState(false);

    const [formData, setFormData] = useState({
        fullName: "",
        email: "",
        password: "",
        location: "",
        mobileNumber: "",
        image: null
    });
    const [errorMessage, setErrorMessage] = useState({
        fullName: "",
        email: "",
        password: "",
        location: "",
        mobileNumber: "",
        image: ""
    });

    useEffect(() => {
        const handleClickOutside = (event) => {

            if (deletePopupRef.current && !deletePopupRef.current.contains(event.target)) {
                setShowDeletePopup(false);
            }

            if (popupRef.current && !popupRef.current.contains(event.target) && !showUploadMediaPopup) {
                setIsNewUserCreate(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showUploadMediaPopup]);

    const fetchCustomers = async () => {
        setIsLoadingData(true)
        try {
            const response = await getCustomers({
                page: currentPage,
            });

            if (response?.data?.result?.length <= 0) {
                setIsLoadingData(false)
            }

            setCustomerList(response?.data?.result);
            setTotalPage(response?.data?.totalPages || 1);
        } catch (error) {
            setCustomerList([]);
            setIsLoadingData(false);
        }
    };

    useEffect(() => {
        fetchCustomers();
    }, [currentPage]);

    useEffect(() => {
        if (selectedFeatureImage) {
            setFormData({
                ...formData,
                image: selectedFeatureImage[0]
            });
        }
    }, [selectedFeatureImage]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        setErrorMessage({ ...errorMessage, [e.target.name]: '' });
    };

    const openAddPopup = () => {
        setFormData({
            fullName: "",
            email: "",
            password: "",
            location: "",
            mobileNumber: "",
        });
        setIsNewUserCreate(true);
        setErrorMessage({
            fullName: "",
            email: "",
            password: "",
            location: "",
            mobileNumber: "",
        })
        setError('')
    };

    const validateForm = () => {
        let errors = {};

        if (!formData.fullName?.trim()) {
            errors.fullName = "First Name is required";
        }
        if (!formData.email?.trim()) {
            errors.email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            errors.email = "Invalid email format";
        }

        if (!formData.password?.trim()) {
            errors.password = "Password is required";
        } else if (formData.password.length < 6) {
            errors.password = "Password must be at least 6 characters";
        }

        if (!formData.mobileNumber?.trim()) {
            errors.mobileNumber = "Mobile number is required";
        } else if (!/^\d{10}$/.test(formData.mobileNumber)) {
            errors.mobileNumber = "Mobile number must be exactly 10 digits";
        }

        setErrorMessage(errors);
        return Object.keys(errors).length === 0;
    };

    const handleSubmit = async () => {
        if (!validateForm()) {
            return;
        }

        try {
            setIsLoading(true);


            await createCustomer({
                fullName: formData.fullName,
                email: formData.email,
                password: formData.password,
                mobileNumber: formData.mobileNumber,
                location: formData.location,
                image: formData?.image?.id || null,
            });

            let updatedList = [formData, ...customerList];
            setCustomerList(updatedList)
            setFormData({
                fullName: '',
                email: '',
                password: '',
                location: '',
                mobileNumber: '',
                image: null
            })
            setIsNewUserCreate(false);
        } catch (error) {
            const message =
                error?.response?.data?.error?.message ||
                'Something went wrong. Please try again.';
            setError(message);
            console.log('Error saving customer:', error);
            // Handle error - you might want to show a notification here
        } finally {
            setIsLoading(false);
        }
    };

    const calculateColumnWidths = async () => {
        return new Promise((resolve) => {
            const tempWidths = customerList?.reduce((acc, row) => {
                Object.keys(row).forEach((key) => {
                    let dataValue;
                    let title;

                    if (key === 'fullName') {
                        dataValue = `${row?.fullName}`;
                        title = 'Name';
                    } else {
                        dataValue = row[key]?.toString();
                        title = key;
                    }

                    let maxContentLength = Math.max(dataValue?.length, title?.length);

                    if (!acc[key] || maxContentLength > acc[key]) {
                        acc[key] = maxContentLength;
                    }
                });
                return acc;
            }, {});

            if (tempWidths !== undefined) {
                const widthMap = Object.keys(tempWidths).reduce((acc, key) => {
                    acc[key] = `${tempWidths[key] * 10 + 40}px`;
                    return acc;
                }, {});
                setColumnWidths(widthMap);
            }
            resolve();
        });
    };

    const handleImageUpload = (e) => {
        e.stopPropagation();
        setShowUploadMediaPopup(true); setUploadMediaPopupFor('feature-image'); setUploadMediaPopupTab('media');
    };

    useEffect(() => {
        if (customerList?.length > 0) {
            calculateColumnWidths();
        }
    }, [customerList]);

    useEffect(() => {
        if (Object.keys(columnWidths).length > 0) {
            setTimeout(() => {
                setIsLoadingData(false);
            }, 1000);
        }
    }, [columnWidths]);

    const handleMasterCheckboxChange = () => {
        if (isAllSelected) {
            setSelectedRows([]);
        } else {
            setSelectedRows(customerList?.map((row) => row?.customerId));
        }
        setIsAllSelected(!isAllSelected);
    };

    const handleExportAllCSV = async () => {
        try {
            setIsExportLoading(true)
            const response = await getAllCustomersWithoutPagination();
            console.log({ response })
            const allData = response?.data || [];

            const columns = [
                { name: 'Email', selector: (row) => row.email },
                { name: 'Name', selector: (row) => row.fullName },
                { name: 'Mobile Number', selector: (row) => row.mobileNumber },
                { name: 'Location', selector: (row) => row.location },
            ];

            exportToCSV(allData, 'customers', columns);
        } catch (error) {
            console.log('Error exporting customers:', error);
        } finally {
            setIsExportLoading(false)
        }
    };

    const columns = [
        {
            name: 'Email',
            selector: (row) => row?.email,
            cell: (row) => <div className='editTitle premium-customer'><Link to={`/customer/${row?.customerId}`}>{row.email}</Link> {row?.isPremium && <img src={premiumIcon} alt="pen-icon" style={{ width: 20}}/>}</div>,
            sortable: true,
            minWidth: columnWidths['email'] ? `${parseInt(columnWidths['email']) + 50}px` : '200px',
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", fontSize: "14px" },

        },
        {
            name: 'Name',
            selector: (row) => row?.fullName,
            cell: (row) => <div>{row.fullName}</div>,
            sortable: true,
            width: columnWidths['fullName'] || '150px',
            style: { width: columnWidths['fullName'] || '150px', paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", fontSize: "14px" },
        },
        {
            name: "Actions",
            cell: (row) => (
                <div className="action-buttons">
                    <button className="edit-btn"><Link to={`/customer/${row?.customerId}`}><img src={penIcon} alt="pen-icon" /></Link></button>
                    <button className="delete-btn" onClick={() => {
                        setDeleteTarget({ type: "single", row });
                        setShowDeletePopup(true);
                        setError('')
                    }}><img src={Delete} alt="delete-icon" /></button>
                </div>
            ),
            width: "90px"
        }
    ];

    const customStyles = {
        headCells: {
            style: {
                fontWeight: 500,
                fontSize: '14px',
            },
        },
    };

    const confirmDelete = async () => {
        if (!deleteTarget) return;

        try {
            setIsDeleteCustomerLoading(true);

            const idsToDelete =
                deleteTarget.type === "single"
                    ? [deleteTarget.row.customerId]
                    : deleteTarget.rows;

            const response = await deleteCustomers(idsToDelete);

            if (response?.success) {
                setShowDeletePopup(false);
                setDeleteTarget(null);
                setSelectedRows([]);
                setIsAllSelected(false);
                setToggleSelect(prev => !prev);
                fetchCustomers();
            }

        } catch (error) {
            console.log('Error deleting customers:', error);
            // Handle error - you might want to show a notification here
        } finally {
            setIsDeleteCustomerLoading(false);
        }
    };

    const handleSearch = async () => {
        try {
            setIsLoadingData(true)
            const response = await getCustomers({ search: searchInput })
            if (response?.data?.result?.length <= 0) {
                setIsLoadingData(false)
            }
            setCustomerList(response?.data?.result);
            setTotalPage(response?.data?.totalPages || 1);
            setIsLoadingData(false)
        } catch (error) {
            setIsLoadingData(false)
            console.log(error, "error");
        }
    }


    return (
        <div className={`customer-page ${customerList?.length <= 10 && 'customer-page-height'}`}>
            <TopBar />
            <div className='customer-datatable-list'>
                <div className="customer-header">
                    <div className="customer-left-side">
                        <div className="search-bar">
                            <img src={searchIcon} alt="Search" />
                            <input
                                type="text"
                                placeholder="Search customers..."
                                value={searchInput}
                                onChange={(e) => setSearchInput(e.target.value)}
                                onKeyPress={(e) => e.key === 'Enter' && handleSearch(searchInput)}
                            />
                        </div>
                        <button className="add-btn" onClick={() => handleSearch(searchInput)}>Search</button>
                    </div>
                    <div className='action-buttons-delete-add'>
                        <button className="add-btn export-btn" onClick={handleExportAllCSV}>
                            {isExportLoading ? (
                                <div className={`ringLoader loaderContinue`}></div>
                            ) :
                                'Export Customers'
                            }
                        </button>
                        <button className="add-btn" onClick={openAddPopup}>Add New Customer</button>
                        {selectedRows?.length > 0 && (
                            <div className="delete-selected-btn" onClick={() => {
                                setDeleteTarget({ type: "multiple", rows: selectedRows });
                                setShowDeletePopup(true);
                            }}>
                                <img src={Delete} alt="delete-icon" />
                            </div>
                        )}
                    </div>
                </div>

                <div className={`pagesTable dataTable-list ${customerList?.length <= 10 && 'dataTable-border-list'} ${(isLoadingData) ? 'loading-list' : ''} `}>
                    <DataTableList
                        columns={columns}
                        data={customerList}
                        onSelectedRowsChange={({ selectedRows }) => {
                            const selectedIds = selectedRows.map((row) => row.customerId);
                            setSelectedRows(selectedIds);
                            setIsAllSelected(selectedIds.length === customerList.length);
                        }}
                        progressPending={isLoadingData}
                        currentPage={currentPage}
                        onChangePage={setCurrentPage}
                        paginationTotalRows={totalPage}
                        selectableRows
                        selectAllRows={isAllSelected}
                        clearSelectedRows={toggleSelect}
                        onSelectAllChange={handleMasterCheckboxChange}
                        customStyles={customStyles}
                        selectableRowsComponent="input"
                        progressComponent={<div className="loader-container"> <div className="loader"></div> </div>}
                    // noDataComponent={<NoResultsPublication />}
                    />
                </div>
            </div>

            <AddNewCustomer
                isNewUserCreate={isNewUserCreate}
                formData={formData}
                handleSubmit={handleSubmit}
                setIsNewUserCreate={setIsNewUserCreate}
                handleChange={handleChange}
                refrence={popupRef}
                errorMessage={errorMessage}
                isLoading={isLoading}
                handleImageUpload={handleImageUpload}
                error={error}
            />

            <DeleteConfirmationPopup
                showDeletePopup={showDeletePopup}
                setShowDeletePopup={setShowDeletePopup}
                reference={deletePopupRef}
                title={deleteTarget?.type === "single" ? 'customer' : selectedRows?.length === 1 ? 'customer' : `customers`}
                description={deleteTarget?.type === "single" ? `Are you sure you want to delete ${deleteTarget?.row?.fullName}?` : selectedRows?.length === 1 ? `Are you sure you want to delete customer?` : `Are you sure you want to delete ${selectedRows?.length} customers?`}
                confirmDelete={confirmDelete}
                isLoading={isDeleteCustomerLoading}
            />
            {showUploadMediaPopup &&
                <UploadMediaPopup showUploadMediaPopup={showUploadMediaPopup} setShowUploadMediaPopup={setShowUploadMediaPopup} setSelectedProfileImage={setSelectedFeatureImage} uploadMediaPopupFor={uploadMediaPopupFor} uploadMediaPopupTab={uploadMediaPopupTab} />
            }
        </div>
    )
}

export default Customers
